query allBasketballPlayers(
  $first: Int,
  $offset: Int,
  $filter: BasketballPlayerFilter,
  $condition: BasketballPlayerCondition
  ) {
  players: allBasketballPlayers(
      first: $first,
      offset: $offset,
      filter: $filter,
      condition: $condition
    ) {
    nodes {
      playerMappings: basketballPlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: basketballTeamMapping { 
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
    }
    totalCount
  }
}
